import { useEffect } from "react";
import useTranslations from "../../../core/i18n/useTranslations";
import { useHistory, useRouteMatch } from "react-router-dom";
import useUser from "../../../core/user/useUser";
import { useSubNav } from "../../../components/LoggedinPage/SubNavContext";
import PageHeader from "../../../ui-lib/components/PageHeader/PageHeader";
import ObservationIdentifiersPage from "../../../components/ObservationIdentifiers/ObservationIdentifiersPage";
import Button from "../../../ui-lib/components/Button/Button";
import styles from "../../PagesLayout.module.css";

const parentPath = "/adminportal/locations";
interface ISubNav {
  key: string;
  to: string;
}

const subMenuItems = (url: string) => {
  const menu: ISubNav[] = [
    {
      key: "Menu:Observation_identifiers",
      to: `${url}`,
    },
  ];
  return menu;
};

const ObjectIdentifiersContainer = () => {
  const user = useUser();
  const t = useTranslations();
  const { url } = useRouteMatch();
  const history = useHistory();
  const { setSubNav } = useSubNav();

  useEffect(() => {
    const nav = {
      menu: subMenuItems(url),
      backUrl: parentPath,
      backText: t("Menu:locations"),
    };
    setSubNav(nav);
    return () => {
      setSubNav(undefined);
    };
  }, [setSubNav, url]);

  useEffect(() => {
    if (!user.hasAccess("EditKnownLocationDataDefinitions")) {
      history.replace(parentPath);
    }
  }, [user, history]);

  return (
    <ObservationIdentifiersPage
      pageId="observation-identifiers"
      tableClassName={styles.content}
    >
      {(onCreate) => (
        <PageHeader title={t("Locations:oi_page_title")} pageTitle>
          <Button
            variant="primary"
            text={t("Locations:oi_add_identifier")}
            onClick={onCreate}
          />
        </PageHeader>
      )}
    </ObservationIdentifiersPage>
  );
};
export default ObjectIdentifiersContainer;
